// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"769":"4fbea5fc","2701":"b7544633"}[chunkId] + ".chunk.css";
};